import React, { FC, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';

interface CountdownProps {
  endDateTime: string;
  onExpire?: () => void;
  className?: string;
  showSeconds?: boolean;
}

const CountdownTimer: FC<CountdownProps> = ({ 
  endDateTime, 
  onExpire, 
  className = '',
  showSeconds = false 
}) => {
  const { formatMessage } = useIntl();
  const [timeLeft, setTimeLeft] = useState('');
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const updateCountdown = () => {
      try {
        const now = new Date().getTime();
        const end = new Date(endDateTime).getTime();
        const difference = end - now;

        if (difference > 0) {
          const days = Math.floor(difference / (1000 * 60 * 60 * 24));
          const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          
          let timeString = '';
          
          if (days > 0) {
            timeString = `${days}d ${hours}h`;
          } else if (hours > 0) {
            timeString = `${hours}h`;
          } else {
            timeString = '< 1h';
          }

          setTimeLeft(timeString);
          setIsExpired(false);
        } else {
          setTimeLeft(formatMessage({ id: 'expired' }) || 'Expired');
          setIsExpired(true);
          onExpire?.();
        }
      } catch (error) {
        console.error('Error calculating countdown:', error);
        setTimeLeft(formatMessage({ id: 'invalid_date' }) || 'Invalid Date');
        setIsExpired(true);
      }
    };

    updateCountdown();

    const timer = setInterval(updateCountdown, 60000);

    return () => clearInterval(timer);
  }, [endDateTime, onExpire, formatMessage]);

  return (
    <span 
      className={`countdown-timer ${isExpired ? 'expired' : 'active'} ${className}`}
      style={{
        color: isExpired ? '#dc3545' : '#28a745',
        fontWeight: 'bold',
        fontSize: '0.9rem'
      }}
    >
      {timeLeft}
    </span>
  );
};

export default CountdownTimer;
